export default {
  CONFIRM_BUTTON_COLOR : "#73c3ab",
  CANCEL_BUTTON_COLOR : "#aaa"
}
